<template>
  <el-container class="product-intro-container">
    <!-- 头部 -->
    <el-header class="product-intro-header">
      <el-row>
        <el-col :span="2">
          <img @click="goToHome()"
               src="~assets/img/logo.png"
               alt="图片无法显示"
               style="height: 42px; cursor: pointer" />
        </el-col>
        <el-col :span="18">
          <div class>当前目的地</div>
        </el-col>
        <!-- 个人中心 -->
        <el-col :span="4">
          <div style="display: flex; height: 40px; margin-top: 10px">
            <a class="J_AppLink"
               href="/account/settings">
              <img src="http://img4.imgtn.bdimg.com/it/u=3701847413,2165986719&fm=11&gp=0.jpg"
                   style="
                  height: 40px;
                  width: 40px;
                  border-radius: 40px;
                  margin-right: 8px;
                " />
            </a>
            <div>
              <p style="
                  height: 20px;
                  line-height: 20px;
                  color: rgb(51, 51, 51);
                  display: flex;
                  align-items: center;
                ">
                <span title="星球玩家俱乐部"
                      style="
                    display: inline-block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    max-width: 150px;
                  ">{{userName}}</span>
              </p>

              <p @click="handleLogout()"
                 style="
                  height: 20px;
                  line-height: 20px;
                  font-size: 12px;
                  color: rgb(153, 153, 153);
                  cursor: pointer;
                ">
                旅行规划师 | 退出
                <i class="next-icon next-icon-arrow-down-filling next-icon-xxs"
                   style="margin-left: 3px; color: rgb(83, 102, 123)"></i>
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-header>
    <!-- 头部over -->
    <el-container class="main-background">
      <!-- ----------------------------左侧导航---------------------------- -->
      <el-aside width="auto"
                class="product_aside">
        <!-- 侧边栏 -->
        <slot name="aside-left-top"></slot>
        <slot name="aside-left"></slot>
      </el-aside>
      <!-- ------------------------------------------ 内容区 ------------------------------------------ -->

      <el-main width="auto"
               class="product_intro_contain">
        <slot name="main"></slot>
      </el-main>
      <!-- -------------------------------------- 弹出对话框部分 -------------------------- -->
      <el-aside width="auto"
                class="product_aside">
        <!-- 侧边栏 -->
        <slot name="aside-right"></slot>
      </el-aside>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'main-farme',
  data() {
    return {
      userName: '',
    }
  },
  mounted() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    console.log()
    this.userName = userInfo.userName
  },
  methods: {
    goToHome() {
      this.$router.push('/booking_data')
    },
    handleLogout() {
      this.$http.delete('/session').then((res) => {
        this.$router.push({ path: '/login' })
      })
    },
  },
}
</script>

<style>
.product-intro-container {
  height: 100%;
  /* height: 500px; */
}

.product-intro-header {
  height: 80px;
  width: 100%;
  background-color: white;
  border-top: 4px solid #ff5421;
  box-shadow: 3px 0 3px rgba(0, 0, 0, 0.3);
  position: fixed;
}

.product_aside {
  /* display: block; */
  margin-top: 80px;
  margin-bottom: 5px;
  float: left;
  /* background-color: rgba(0, 0, 0, 0.1); */
  /* background-color: #ff5421; */
  padding: 0 20px 0 15px;
  /* border: 1px solid #e5e9f2; */
  border-radius: 3px;
  /* flex: 0 0; */
  /* overflow: auto; */
}

.main-background {
  /* display: flex; */
  height: 100vh;
  width: 100%;
  /* padding: 0 5px; */
  /* margin: 15px auto; */
  align-content: center;
  justify-content: center;
  background-color: rgb(241, 236, 235);
}

.product_intro_contain {
  display: block;
  margin-top: 80px;
  margin-bottom: 5px;
  padding: 0 0px 0px 0px;
  /* width: 1000px; */
  width: 75%;
  flex: initial;
  overflow: auto;
}
</style>